import { getCookie } from '@/utils/cookie'
import Url from '@mc/mc-utils/js/url/url'
import { miniProgramEnv } from '@/defines/environment'

const getFromUrl = () => {
  const url = new Url(window.location.href)
  const { company_id: companyId } = url.parseQuerystring()
  return companyId
}

export const getCompanyId = userInfo => {
  if (userInfo.companyId) {
    return userInfo.companyId
  } else if (miniProgramEnv.isMiniProgram) {
    return getFromUrl()
  } else {
    return getCookie('mc_loguser_company')
  }
}
